module.exports = __webpack_public_path__ + "img/cards.700b380f.png";